import viewNames, { initialView } from '../actions/view.types';

const initialState = initialView;

function currentView(state = initialState, action = {}) {
  if (!action.type) return state;

  return viewNames[action.type] || state;
}

export { currentView }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/store/reducers/views.js